import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "cookie-consent";

export function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      const t = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const handleChoice = (choice: "accepted" | "declined") => {
    localStorage.setItem(STORAGE_KEY, choice);
    localStorage.setItem(`${STORAGE_KEY}-date`, new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="הסכמה לעוגיות"
      dir="rtl"
      className="fixed bottom-0 inset-x-0 z-[100] p-4 md:p-6 animate-in slide-in-from-bottom-5 duration-500"
    >
      <div className="mx-auto max-w-4xl bg-card border border-border shadow-2xl rounded-2xl p-5 md:p-6 backdrop-blur-sm">
        <div className="flex flex-col md:flex-row md:items-center gap-4 md:gap-6 text-right">
          <div className="flex items-start gap-3 flex-1">
            <div className="shrink-0 h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
              <Cookie className="h-5 w-5 text-primary" />
            </div>
            <div className="flex-1">
              <h2 className="font-semibold text-foreground mb-1">
                אנחנו משתמשים בעוגיות 🍪
              </h2>
              <p className="text-sm text-muted-foreground leading-relaxed">
                אנחנו משתמשים בעוגיות כדי לשפר את חוויית הגלישה שלך, לנתח תעבורה
                ולהתאים תוכן. ניתן לקרוא עוד ב
                <a
                  href="/privacy"
                  className="text-primary hover:underline font-medium mx-1"
                >
                  מדיניות הפרטיות
                </a>
                שלנו.
              </p>
            </div>
          </div>
          <div className="flex flex-row-reverse gap-2 shrink-0 justify-end">
            <Button
              onClick={() => handleChoice("accepted")}
              className="min-w-[100px]"
            >
              אישור
            </Button>
            <Button
              variant="outline"
              onClick={() => handleChoice("declined")}
              className="min-w-[100px]"
            >
              דחייה
            </Button>
          </div>
          <button
            onClick={() => handleChoice("declined")}
            aria-label="סגור"
            className="absolute top-3 left-3 md:hidden text-muted-foreground hover:text-foreground"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
